import React from 'react';
import { Text } from '@fluentui/react';
import { SearchRegular, DismissRegular } from '@fluentui/react-icons';
import styles from './FeatureSearch.module.css';

type FilterCategory = 'all' | 'source' | 'feature';

interface FeatureSearchProps {
  value: string;
  onChange: (value: string) => void;
  activeCategory: FilterCategory;
  onCategoryChange: (category: FilterCategory) => void;
}

const FeatureSearch: React.FC<FeatureSearchProps> = ({
  value,
  onChange,
  activeCategory,
  onCategoryChange
}) => {
  const categories: { key: FilterCategory; label: string; icon: string }[] = [
    { key: 'all', label: 'All', icon: '📋' },
    { key: 'source', label: 'Data Sources', icon: '🔍' },
    { key: 'feature', label: 'Features', icon: '⚙️' }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.searchWrapper}>
        <SearchRegular className={styles.searchIcon} />
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search features, trigger words, or example queries..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <button 
            className={styles.clearButton}
            onClick={() => onChange('')}
            aria-label="Clear search"
          >
            <DismissRegular />
          </button>
        )}
      </div>

      <div className={styles.filters}>
        <Text className={styles.filterLabel}>Filter:</Text>
        <div className={styles.filterButtons}>
          {categories.map(cat => (
            <button
              key={cat.key}
              className={`${styles.filterButton} ${activeCategory === cat.key ? styles.active : ''}`}
              onClick={() => onCategoryChange(cat.key)}
            >
              <span className={styles.filterIcon}>{cat.icon}</span>
              <span>{cat.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureSearch;
